import { Divider } from "@mui/material";

const DottedDivider = () => <Divider sx={{ borderStyle: "dashed" }} />;

export default DottedDivider;
